import { useContext } from "react";
import { useHistory } from "react-router";
import { RESOURCE_NAME } from "common/authorization";
import { buildLink } from "common/routing";
import { SubmissionType } from "../../../../generated/graphql";
import { AuthContext } from "../../../Authorization/AuthContext";
import DropdownMenu, { ActionsProps } from "../../../Inputs/DropdownMenu";
import { useDeleteSubmissionTypeModal } from "./DeleteSubmissionTypeModal";

export type ActionButtonProps = {
  submissionType: Pick<SubmissionType, "id" | "name" | "isDeletable">;
  onDeleteSuccess: () => void;
};

export const ActionButton = ({
  submissionType,
  onDeleteSuccess,
}: ActionButtonProps) => {
  const history = useHistory();
  const { authorized } = useContext(AuthContext);

  const canEditSubmissionType = authorized({
    resource: RESOURCE_NAME.SUBMISSION_TYPE,
    permission: "update",
  });

  const canDeleteSubmissionType = authorized({
    resource: RESOURCE_NAME.SUBMISSION_TYPE,
    permission: "delete",
  });

  const showDeleteSubmissionTypeModal = useDeleteSubmissionTypeModal({
    onDeleteSuccess,
  });

  const deleteDisabled =
    !canDeleteSubmissionType || !submissionType.isDeletable;

  const actions: Array<ActionsProps> = [
    {
      label: "Edit record type",
      disabled: !canEditSubmissionType,
      onClick: () => {
        history.push({
          pathname: buildLink("submissionsBuilderV2", {
            submissionTypeId: submissionType.id,
          }),
          state: {
            prevLocation: history.location.pathname,
          },
        });
      },
    },
    {
      label: "Delete",
      variant: "red" as const,
      disabled: deleteDisabled,
      onClick: () => showDeleteSubmissionTypeModal(submissionType),
    },
  ];

  return <DropdownMenu actions={actions} isTableAction />;
};
